var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-divider',{attrs:{"direction":_vm.direction,"content-position":_vm.cntPosition}},[_c('VelIcon',{attrs:{"iconName":_vm.icon,"iconText":_vm.lineText}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }